import { render, staticRenderFns } from "./SickLeaveTempForm.vue?vue&type=template&id=1ecef74c"
import script from "./SickLeaveTempForm.vue?vue&type=script&lang=js"
export * from "./SickLeaveTempForm.vue?vue&type=script&lang=js"
import style0 from "./SickLeaveTempForm.vue?vue&type=style&index=0&id=1ecef74c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports